// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { getNestedByString, setNestedValueInObject } from 'helpers/reduxFormFunctions'
import { fetchRadioByRadioCode } from 'helpers/api'
import { UNCAUGHT_ERROR } from 'errors'

// to make sure the radio code is unique, we hit the /radio API and if it returns
// a 404 we're good, the code doesn't exist. but if it returns an entity, then it's not unique.
// so in this scenario we actually want to .catch() the 404 for success. the .then() will
// cause an error in the UI for this input field.
const radioCodeIsUnique = async (formValues, f, props, pathString) => {
  const {
    asyncErrors = {},
  } = props

  // no need to run this validation on submit.
  if (!pathString) {
    return
  }

  const hasAsyncErrors = Object.keys(asyncErrors).length
  const v = getNestedByString(formValues, pathString)

  // don't hit the api if there's no value to check against.
  if (!hasAsyncErrors && !v.length) {
    return
  } else if (!v.length) {
    // even if there's no value, throw the asyncErrors object since
    // there may already be other async errors that we want to keep
    throw asyncErrors
  }

  try {
    const { entity } = await fetchRadioByRadioCode(v)
    // if API returned an entity, than it's not unique
    if (entity) {
      throw new Error('Radio Code is not unique.')
    }
  } catch (err) {
    const {
      message = UNCAUGHT_ERROR,
      res = {},
    } = err

    if (res.status === 404 && hasAsyncErrors) {
      // antenna code was unique but there were previous async errors we want to persist.
      throw asyncErrors
    } else if (res.status === 404) {
      // antenna code was unique and there are no async errors to persist.
      return
    }

    // if the API error was not 404, capture the API's error message and throw that
    console.warn(err)
    setNestedValueInObject(asyncErrors, pathString, message)
    throw asyncErrors
  }

  // not sure how a user would get here but just in case, we'll pass
  // along any previous async errors which were on the form.
  if (hasAsyncErrors) {
    throw asyncErrors
  }
}

export default radioCodeIsUnique
